// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__FCffF","col":"CardReaderDesc_col__GFjtb","label":"CardReaderDesc_label__2bMYX"};